<h4 class="my-3">Jefes de taller</h4>

<ngb-accordion #acc="ngbAccordion" class="actions-accordion" *ngIf="model">
  <ngb-panel *ngFor="let supervisor of model">
    <ng-template ngbPanelHeader>
      <button ngbPanelToggle class="accordion-button bg-light">
        <div class="supervisor">
          <strong>{{supervisor.UserName}}</strong>
        </div>
        <div class="remuneracion">
          <span class="label_data">Remuneración</span><br>
          {{supervisor.TotalRemuneration | currency:'EUR'}}
        </div>
      </button>
    </ng-template>
    <ng-template ngbPanelContent>
      <h4>Receptores:</h4>
      <div class="table__resume table-responsive-lg">
        <table class="table">
          <thead>
            <tr>
              <th>Nombre completo</th>
              <th>Subacción</th>
              <th>Unidades vendidas</th>
              <th>Remuneración</th>
              <th>€/Unidades</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let receptor of supervisor.RenaultAnimationSubactionsUser">
              <td class="text-left">{{receptor.UserName}}</td>
              <td>{{receptor.Title}}</td>
              <td class="table-active w-12">{{receptor.SoldUnits}}</td>
              <td class="table-active w-12">{{receptor.SoldTotalPrice | currency:'EUR'}}</td>
              <td class="table-active w-12">{{receptor.SoldPricePerUnit | currency:'EUR'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </ngb-panel>
</ngb-accordion>